import { DATA_TESTID, Text_INTERNAL } from "../Text_INTERNAL";
import type { TextInternalProps } from "../Text_INTERNAL";

export const styleProps = {
  size: "text-2xl md:text-4xl",
  leading: "leading-10",
  weight: "font-bold",
};

export interface TitleXlProps extends TextInternalProps {
  "data-testid"?: string;
}

export const TitleXl = ({
  color,
  truncate,
  [DATA_TESTID]: dataTestId,
  children,
  ...otherProps
}: TitleXlProps) => {
  const props = {
    ...styleProps,
    color,
    truncate,
    dataTestId,
    ...otherProps,
  };

  return (
    <Text_INTERNAL as="h2" {...props}>
      {children}
    </Text_INTERNAL>
  );
};
